import { getSchema } from "@tiptap/core";

import StarterKit from "@tiptap/starter-kit";
import { TableKit } from "@tiptap/extension-table";

import LinkCard from "./extensions/link-card/linkCardExtension";
import TextAlign from "@tiptap/extension-text-align";
import { ListKit } from "@tiptap/extension-list";
import TaskList from "@tiptap/extension-task-list";
import TaskItem from "@tiptap/extension-task-item";
import Highlight from "@tiptap/extension-highlight";
import { TextStyle, Color } from "@tiptap/extension-text-style";
import { ImageUploadExtension } from "./extensions/upload";
import { VideoEmbed } from "./extensions/video-embed";
import { PdfEmbed } from "./extensions/pdf-embed";
import { CodeBlockWithLowlight } from "./extensions/code-block";
import { ResizableImage } from "./extensions/resizable-image";
import { Strike } from "@tiptap/extension-strike";
import Image from "@tiptap/extension-image";

import FileChipNode from "./extensions/upload/FileNode";
import ImagePlaceholder from "./extensions/upload/ImageNode";

/**
 * Schema for prosemirrorJSONToYDoc conversion.
 * IMPORTANT: This schema must match the extensions used in TipTapEditor.tsx
 * to ensure proper Yjs update generation from TipTap JSON content.
 */
export const schema = getSchema([
  ListKit.configure({ taskList: false, taskItem: false }),
  LinkCard,
  FileChipNode,
  ImagePlaceholder,
  TaskList,
  TaskItem,
  StarterKit.configure({
    codeBlock: false,
  }),
  Strike,
  TextAlign.configure({
    types: ["heading", "paragraph"],
  }),
  TableKit,
  Highlight.configure({
    multicolor: true,
  }),
  TextStyle,
  Color,
  ImageUploadExtension,
  VideoEmbed,
  PdfEmbed,
  CodeBlockWithLowlight,
  ResizableImage,
  // Include standard Image extension for backward compatibility with content
  // that may have 'image' nodes instead of 'resizableImage' nodes
  Image,
]);
